import { ProcessStatusCode } from "@/types/code.types";

// Patent List 검색 옵션 (search type): All Info, Id, Publication Number, Title
export type PatentPressInfoFilterKey =
  | "allInfo"
  | "idInfo"
  | "publicationNumber"
  | "title";

export interface PatentPressInfoFilterType {
  key: PatentPressInfoFilterKey;
  name: string;
  isAllInfo: boolean;
  code?: ProcessStatusCode;
}

export const PATENT_LIST_INFO_FILTER: PatentPressInfoFilterType[] = [
  {
    key: "allInfo",
    name: "All Info",
    isAllInfo: true,
  },
  {
    key: "idInfo",
    name: "Id",
    isAllInfo: false,
  },
  {
    key: "publicationNumber",
    name: "Publication Number",
    isAllInfo: false,
  },
  {
    key: "title",
    name: "Title",
    isAllInfo: false,
  },
];

export const PATENT_LIST_PRESS_INFO_FILTER_KEY = [
  "allInfo",
  "idInfo",
  "publicationNumber",
  "title",
] as const;